import React from 'react';

import styled from 'styled-components';

import CommunityIncentives from 'components/CommunityInfo/incentives/CommunityIncentives';
import Button from 'components/lib/Button';
import Modal from 'components/lib/Modal';
import { OWNERSHIP_TYPES } from 'constants/ownership';
import { CommunityType } from 'types/communities';

const StyledModal = styled(Modal).attrs({
  className: 'manage-incentives-modal',
})`
  .ant-modal-header {
    border-bottom: 1px solid var(--line-gray);
    padding: 25px 30px 20px !important;
    margin-bottom: 0;
  }

  .ant-modal-content {
    width: 75vw;
  }

  .ant-modal-body {
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding-top: 30px;
  padding-bottom: 7px;
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
`;

const TitleIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: var(--positive-green);
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 var(--box-shadow-pink);
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 40px;
`;

const Footer = styled.div`
  margin-top: 20px;
  margin-right: -30px;
  margin-left: -30px;
  padding: 20px 30px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--line-gray);
`;

type Props = {
  openModal: boolean;
  communityInfo: CommunityType | undefined;
  onClose: () => void;
};

const ManageIncentivesModal = ({ openModal, communityInfo, onClose }: Props) => {
  return (
    <>
      <StyledModal open={openModal} onCancel={onClose} footer={null} title={'Manage Incentives'} width="fit-content">
        <div>
          <Label>{communityInfo?.comunity_name}</Label>
          <TitleContainer>
            <TitleIcon>
              <img
                src={'/icons/local-offer.svg'}
                alt="CommunityInfo"
                style={{
                  width: 24,
                  height: 24,
                }}
              />
            </TitleIcon>
            <Title>Incentives</Title>
          </TitleContainer>
          <CommunityIncentives communityInfo={communityInfo} ownershipType={OWNERSHIP_TYPES.SHARED} />
        </div>
        <Footer>
          <Button onClick={onClose}>Close</Button>
        </Footer>
      </StyledModal>
    </>
  );
};

export default ManageIncentivesModal;
